import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Wallet } from '../utils/wallet';

const Navigation: React.FC = () => {
  const location = useLocation();
  const [credits, setCredits] = useState<number>(0);

  // Initialize credits on component mount
  useEffect(() => {
    setCredits(Wallet.getCredits());
  }, []);

  // Poll for credit changes every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      const currentCredits = Wallet.getCredits();
      setCredits(currentCredits);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="nav">
      <div className="hidden-code w-embed">
        <style>
          {`.link-nav:not(.active) .link-nav--indicator{
            opacity:0;
          }`}
        </style>
      </div>
      
      <div className="nav-acount">
        <div className="account-icon">@</div>
        <div className="account-label">Login</div>
      </div>
      
      <div className="nav-links">
        <Link 
          to="/" 
          className={`link-nav w-inline-block ${isActive('/') ? 'active' : ''}`}
        >
          <div className="link-nav--indicator"></div>
          <div className="link-nav--label">League</div>
        </Link>
        
        <Link 
          to="/rosters" 
          className={`link-nav w-inline-block ${isActive('/rosters') ? 'active' : ''}`}
        >
          <div className="link-nav--indicator"></div>
          <div className="link-nav--label">Rosters</div>
        </Link>
        
        <Link 
          to="/games" 
          className={`link-nav w-inline-block ${isActive('/games') ? 'active' : ''}`}
        >
          <div className="link-nav--indicator"></div>
          <div className="link-nav--label">Games</div>
        </Link>
      </div>
      
      <div className="nav-wallet">
        <div className="wallet-label">Wallet:</div>
        <div className="wallet-amount">{credits.toLocaleString()}</div>
        <div className="wallet-icon">Σ</div>
      </div>
    </div>
  );
};

export default Navigation; 